import {
  mdiFile,
  mdiFileImage,
  mdiFileMusic,
  mdiFilePdf,
  mdiFilePowerpoint,
  mdiFileTable,
  mdiFileVideo,
  mdiFileWord,
} from '@mdi/js';

export const isAcceptedFileType = (file: File, accept: string) => {
  if (accept === '*') {
    return true;
  }

  const acceptedFileTypes = accept.split(',');
  const fileExtension = getFileExtension(file);

  return fileExtension && acceptedFileTypes.includes(`.${fileExtension}`);
};

export const getFileExtension = (file: File | string) => {
  const name = typeof file === 'string' ? file : file.name;
  return name.toLowerCase().split('.').pop();
};

export const getFileIcon = (file: File | string) => {
  const fileExtension = getFileExtension(file);

  if (!fileExtension) {
    return mdiFile;
  }

  if (['pdf'].includes(fileExtension)) {
    return mdiFilePdf;
  }

  if (['png', 'jpg', 'jpeg', 'tiff'].includes(fileExtension)) {
    return mdiFileImage;
  }

  if (['doc', 'docx'].includes(fileExtension)) {
    return mdiFileWord;
  }

  if (['xls', 'xlsx', 'ods', 'csv'].includes(fileExtension)) {
    return mdiFileTable;
  }

  if (['ppt', 'pptx'].includes(fileExtension)) {
    return mdiFilePowerpoint;
  }

  if (['mp3', 'wav', 'wma'].includes(fileExtension)) {
    return mdiFileMusic;
  }

  if (['mp4', 'avi', 'wmv', 'mov'].includes(fileExtension)) {
    return mdiFileVideo;
  }

  return mdiFile;
};

export const getFormattedDate = (param?: File | number | string) => {
  if (!param) {
    return '';
  }

  if (typeof param === 'string') {
    return param;
  }

  if (typeof param === 'number') {
    return new Date(param).toLocaleString('pt-BR');
  }

  return new Date(param.lastModified).toLocaleString('pt-BR');
};
